import React, { useState } from 'react';

import EditorSearchIcon from '@atlaskit/icon/glyph/editor/search';
import Textfield from '@atlaskit/textfield';
import Tooltip from '@atlaskit/tooltip';

import { Utils } from '@qality/common-utils';

import {
  SearchSelectContainerStyled,
  SearchSelectCss,
} from './SearchSelect.styled';

type Props = {
  onChange: (selected: [{ name: string; value: string }]) => undefined;
  requirementTypeName: string;
  search: string;
  isDisabled: boolean;
  tooltip?: string;
};

const SearchSelect: React.FC<Props> = ({
  onChange,
  requirementTypeName,
  search,
  isDisabled,
  tooltip,
}: Props) => {
  const [fieldValue, setFieldValue] = useState(search ? search : '');

  const handleTextFieldChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const inputValue = e.currentTarget?.value;
    const useFallbackValue = Utils.isNilOrEmpty(inputValue);
    const selectedInput = useFallbackValue ? '' : inputValue;

    setFieldValue(selectedInput);
    onChange([{ name: 'search', value: selectedInput }]);
  };

  return (
    <SearchSelectContainerStyled>
      <Tooltip content={tooltip}>
        <Textfield
          id='qality-search-select'
          isDisabled={isDisabled}
          className='search-select'
          elemBeforeInput={<EditorSearchIcon label='search-select-icon' />}
          placeholder={
            !requirementTypeName || requirementTypeName === ''
              ? 'Search test case'
              : 'Search requirement'
          }
          css={SearchSelectCss}
          onChange={handleTextFieldChange}
          value={fieldValue}
        />
      </Tooltip>
    </SearchSelectContainerStyled>
  );
};

export default SearchSelect;
